import queryString from 'query-string';

export default function(route) {
  const isPageWithPaging = !!route.page;
  const pageNumber = isPageWithPaging && parseFloat(route.page);
  const shouldSetNoIndex = route.shouldSetNoIndex;
  const shouldSetIndex = route.shouldSetIndex;
  const shouldCanonicalizePage =
    !shouldSetNoIndex && Object.keys(route.query).find(key => key !== 'page');

  const stringifiedQuery = queryString.stringify(route.query);
  const stringifiedPrevQuery =
    pageNumber >= 1
      ? queryString.stringify({
          page: pageNumber > 2 ? pageNumber - 1 : undefined,
        })
      : '';
  const stringifiedNextQuery =
    pageNumber && pageNumber < 100 && !route.isLastPage
      ? queryString.stringify({
          page: pageNumber + 1,
        })
      : '';

  const isAdvertPage = route.type === 'advert';

  return {
    isAdvertPage,
    pageNumber,
    shouldSetIndex,
    shouldSetNoIndex,
    shouldCanonicalizePage,
    stringifiedPrevQuery: stringifiedPrevQuery ? `?${stringifiedPrevQuery}` : '',
    stringifiedNextQuery: stringifiedNextQuery ? `?${stringifiedNextQuery}` : '',
    stringifiedQuery: stringifiedQuery ? `?${stringifiedQuery}` : '',
  };
}



// WEBPACK FOOTER //
// ./src/metaBuilder.js